import React, { FC, ReactNode } from 'react';

import { AppFormattedMessage } from '../../../../components/app-formatted-message/index';
import Button from '../../../../components/button/index';

const secondaryButtonClassName =
  'h-11 w-fit rounded border border-gray-300 bg-white px-6 text-sm font-[450] text-gray-700 transition-colors duration-200 hover:bg-gray-50 motion-reduce:transition-none';

export type AdjustPoolSizeFooterProps = {
  confirmLabel: ReactNode;
  isConfirmDisabled: boolean;
  isPending?: boolean;
  onBack?: () => void;
  onCancel: () => void;
  onConfirm: () => void;
};

export const AdjustPoolSizeFooter: FC<AdjustPoolSizeFooterProps> = ({
  confirmLabel,
  isConfirmDisabled,
  isPending,
  onBack,
  onCancel,
  onConfirm,
}) => (
  // The modal stacks its sections 16px apart; the footer sits 24px below them.
  <div className="mt-2 flex w-full items-center justify-between gap-3">
    <Button className={secondaryButtonClassName} onClick={onCancel} styleType="NONE">
      <AppFormattedMessage id="CANCEL" />
    </Button>
    <div className="flex items-center gap-3">
      {onBack && (
        <Button className={secondaryButtonClassName} onClick={onBack} styleType="NONE">
          <AppFormattedMessage id="BACK" />
        </Button>
      )}
      <Button
        className="h-11 w-fit whitespace-nowrap px-6 py-[10px] transition duration-200 motion-reduce:transition-none"
        disabled={isConfirmDisabled}
        isLoading={isPending}
        onClick={onConfirm}
      >
        {confirmLabel}
      </Button>
    </div>
  </div>
);
